import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../providers/nav.service';
// import { ApiService } from '../providers/api.service';
// import { ToastrService } from 'ngx-toastr';
// import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  constructor(
    private route: Router,
    private navService: NavService,
  ) { }

  ngOnInit() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
  }

  ngOnDestroy() {
    const user: any = JSON.parse(localStorage.getItem('userDetails'));
    let currentUrl = this.route.url;
    if (currentUrl == '/') {
      currentUrl = '/DashBoard';
    }
    this.navService.changeNavHeaderActive(currentUrl);
    if (user && user.isLogin == true && (this.route.url == '/' || this.route.url == '/SignIn' || this.route.url == '/SignUp')) {
      this.route.navigate(['/DashBoard']);

    } else if (user && user.isLogin == false && (user.isSkip == true || user.isSocialLogin == true) && (this.route.url == '/' || this.route.url == '/SignIn' || this.route.url == '/SignUp')) {
      this.route.navigate(['/DashBoard']);
    }

  }

  onBoard() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Board']);
  }

  onTrends() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Trends']);
  }

  onLast5() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Last5']);
  }

  onManager() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Manager']);
  }

  getFilteredData(data) {
    // console.log(data);
  }

  goToTour(){
    this.route.navigate(['/Board'],{queryParams: {tour: 'yes'}});
  }
}
